<template>
    <div class="m-invest-block">
        <div class="container">
            <div class="section-title-box">
                <h1 class="section-title">Выгодные предложении</h1>
            </div>
            <div>
                <div class="section-select-block">
                    <p class= "section-select" @click="getProducts('hit')">ХИТ</p>
                    <p class= "section-select" @click="getProducts('is_new')">НОВОСТИ</p>
                    <p class= "section-select" @click="getProducts('is_suggested')">ПРЕДЛАГАЕТСЯ</p>
                </div>
            </div>
        </div>
        <div class="m-invest-blocks slider-main-container">
            <swiper
                :slidesPerView="1"
                :spaceBetween="30"
                :freeMode="true"
                :autoplay="{
                   delay: 5000,
                   disableOnInteraction: false,
                   pauseOnMouseEnter: true,
                }"
                :navigation="true"
                :pagination="{
                  clickable: true,
                }"
                :breakpoints="{
                  '575': {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  '768': {
                    slidesPerView: 2,
                    spaceBetween: 40,
                  },
                  '1024': {
                    slidesPerView: 3,
                    spaceBetween: 70,
                  },
                }"
                :modules="modules"
                class="projectsTopSlider main-slide main-slide--with-nav"
            >
                <swiper-slide v-for="invest in products" :key="invest.id">
                    <a class="m-invest-block2" :href="`/product/${invest.slug}`">
                        <swiper :navigation="true" :pagination="true" :loop="true" :modules="modules" class="mySwiper singleProjectSlider">
                            <swiper-slide v-for="img in invest.attachments" :key="img.id">
                                <div class="img-wrap project-img-wrap">
                                    <image-wrap class="m-invest-img image" :image="img" size="medium"></image-wrap>
                                    <!-- <img loading="lazy" :src=img.urls.medium class="m-invest-img image"> -->
                                </div>
                            </swiper-slide>
                        </swiper>
                    </a>
                        <div class="m-invest-info">
                            <a class="m-invest-block2" :href="`/product/${invest.slug}`">
                                <p class="m-invest-name">{{invest.title}}</p>
                                <div class="m-invest-info-div">
                                </div>
                            </a>
                            <div class="m-contacts-div">
                                <order-popup-btn-small :product="invest"></order-popup-btn-small>
                                <a :href="`/product/${invest.slug}`" class="m-contact-a">
                                    <i class="fas fa-file-signature m-contact-img" width="18"></i>
                                    <p class="m-contact-p" >Код-{{invest.sku}}</p>
                                </a>
                            </div>
                        </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>
<script setup>
import {ref, defineProps, onMounted} from 'vue';
import { useStore } from 'vuex'

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination} from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const store = ref(useStore())

    const products = ref(null)

    async function getProducts (type){
            const {data} = await axios.get('/get-product-by/' + (type || ''));
            products.value = data.products;
    }
    getProducts('hit')
const components = {
    Swiper,
    SwiperSlide,
}
const modules = [
    Navigation,
    Pagination,
    Autoplay
]

const prev = ref(null);
const next = ref(null);
const pagination = ref(null);
onMounted(() => {
    prev
    next
    pagination
})
</script>

<style>
.m-invest-block{
    min-height: 300px;
    margin-top: 50px;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 50px;
    background-color: white;
    @media screen and (max-width: 1024px) {
        gap: 30px;
        margin-top: 80px;
        padding-bottom: 20px;
    }
    @media screen and (max-width: 768px) {
        margin-top: 40px;
    }
    
    .m-invest-title{
        font-size: 36px;
        color:  #131313;
        line-height:1.3;
        @media screen and (max-width: 1024px) {
            font-size: 32px;
        }
    }
    .m-invest-blocks{
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 76px;
        @media screen and (max-width: 1024px) {
            gap: 30px;
        }
        @media screen and (max-width: 768px){
            flex-wrap: wrap;
        }
       .m-invest-block2{
           margin-top: 0;
           display: flex;
           flex-direction: column;
           gap: 6px;
           background-color: white;
           border-radius: 10px;
           overflow: hidden;
           .m-invest-img {
               width: 100%;;
           }
           .swiper-button-prev,
           .swiper-button-next {
               height: 50px;
               width: 32px;
               background-size: cover;
               background-position: center;
               background-repeat: no-repeat;
               @media screen and (max-width: 768px){
                   height: 29px;
                   width: 18px;
               }
               &.swiper-button-disabled {
                   opacity: 0.5;
               }
               &::after {
                   content: none;
               }
           }
           .swiper-button-prev {
               background-image: url("/images/projects/arrow-prev.svg");
           }
           .swiper-button-next {
               background-image: url("/images/projects/arrow-next.svg");
           }
       }
    }
    .m-invest-info{
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 24px 24px 10px;
        text-align: left;
    }
    .m-invest-info-div{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .m-invest-name{
        border-bottom: 2px solid #3c5757;
        font-size: 22px;
        color:#3c5757;
        line-height:1.3;
        margin-bottom: 16px;
        text-align: center;
        @media screen and (max-width: 1024px) {
            font-size: 18px;
        }
    }
    .m-invest-info-single{
        display: flex;
        gap: 11px;
        margin-bottom: 12px;
    }
    .m-invest-info-single-p{
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-weight: normal;
        color:#000000;
    }
    .m-invest-info-img{
        height: 18px;
        width: auto;
    }
    .m-contacts-div{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .m-contact-a{
        display: flex;
        gap: 8px;
        align-items: center;
        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }
    .m-contact-p{
        font-size: 14px;
        color: black;
        white-space: nowrap;
    }
    .m-contact-img{
        height: 15px;
        width: auto;
        color: #3c5757;
    }
    .swiper-horizontal {
        width: 100%;
    }
    .slider-main-container {
        padding: 0 30px;
    }
    .section-select-block {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap:20px;
        color:#3c5757;
        .section-select {
            font-weight: 700;
            transition: all .3s ease;
            &:hover {
                font-size: 20px;
                text-decoration: underline;
                transition: all .3s ease;
                cursor: pointer;
            }
        }

    }
}
</style>